// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/accounting.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { FilterGroup, PageRequest, PageResponse, SortSpec } from "./common_pb.js";

/**
 * @generated from enum omnios.v1.Side
 */
export const Side = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.Side",
  [
    {no: 0, name: "SIDE_UNSPECIFIED"},
    {no: 1, name: "DEBIT"},
    {no: 2, name: "CREDIT"},
  ],
);

/**
 * @generated from enum omnios.v1.EntryStatus
 */
export const EntryStatus = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.EntryStatus",
  [
    {no: 0, name: "ENTRY_STATUS_UNSPECIFIED"},
    {no: 1, name: "DRAFT"},
    {no: 2, name: "PENDING_APPROVAL"},
    {no: 3, name: "APPROVED"},
    {no: 4, name: "POSTED"},
    {no: 5, name: "REVERSED"},
  ],
);

/**
 * @generated from enum omnios.v1.PeriodStatus
 */
export const PeriodStatus = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.PeriodStatus",
  [
    {no: 0, name: "PERIOD_STATUS_UNSPECIFIED"},
    {no: 1, name: "OPEN"},
    {no: 2, name: "SOFT_CLOSED"},
    {no: 3, name: "CLOSED"},
    {no: 4, name: "REOPENED"},
  ],
);

/**
 * @generated from enum omnios.v1.AccountType
 */
export const AccountType = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.AccountType",
  [
    {no: 0, name: "ACCOUNT_TYPE_UNSPECIFIED"},
    {no: 1, name: "ASSET"},
    {no: 2, name: "LIABILITY"},
    {no: 3, name: "EQUITY"},
    {no: 4, name: "REVENUE"},
    {no: 5, name: "EXPENSE"},
    {no: 6, name: "OCI"},
  ],
);

/**
 * @generated from enum omnios.v1.DecisionStatus
 */
export const DecisionStatus = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.DecisionStatus",
  [
    {no: 0, name: "DECISION_STATUS_UNSPECIFIED"},
    {no: 1, name: "PROPOSED"},
    {no: 2, name: "APPROVED_DECISION"},
    {no: 3, name: "REJECTED"},
    {no: 4, name: "AUTO_EXECUTED"},
    {no: 5, name: "EXPIRED"},
  ],
);

/**
 * @generated from message omnios.v1.JournalEntry
 */
export const JournalEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.JournalEntry",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entry_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "valid_date", kind: "message", T: Timestamp },
    { no: 8, name: "record_time", kind: "message", T: Timestamp },
    { no: 9, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "status", kind: "enum", T: proto3.getEnumType(EntryStatus) },
    { no: 11, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "entry_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "origin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "reverses_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: "posted_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "approved_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 19, name: "groups", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 20, name: "lines", kind: "message", T: JournalLine, repeated: true },
    { no: 21, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.JournalLine
 */
export const JournalLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.JournalLine",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 6, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "reporting_amounts", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 9, name: "dimensions", kind: "message", T: Struct },
    { no: 10, name: "quantity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "tax_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.Account
 */
export const Account = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Account",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "account_type", kind: "enum", T: proto3.getEnumType(AccountType) },
    { no: 6, name: "normal_balance", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 7, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_group", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "is_template", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "dimensions", kind: "message", T: Struct },
    { no: 12, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "properties", kind: "message", T: Struct },
    { no: 15, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.FiscalPeriod
 */
export const FiscalPeriod = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FiscalPeriod",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_date", kind: "message", T: Timestamp },
    { no: 5, name: "end_date", kind: "message", T: Timestamp },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(PeriodStatus) },
    { no: 7, name: "close_checklist", kind: "message", T: CloseChecklist },
    { no: 8, name: "closed_at", kind: "message", T: Timestamp },
    { no: 9, name: "closed_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.FixedAsset
 */
export const FixedAsset = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FixedAsset",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "asset_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "acquisition_cost", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "salvage_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "useful_life_months", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "depreciation_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "accumulated_depreciation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "carrying_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "acquisition_date", kind: "message", T: Timestamp },
    { no: 13, name: "disposal_date", kind: "message", T: Timestamp },
    { no: 14, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "depreciation_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "properties", kind: "message", T: Struct },
    { no: 17, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.AccountBalance
 */
export const AccountBalance = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AccountBalance",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_debits", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_credits", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "net", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "normal_balance", kind: "enum", T: proto3.getEnumType(Side) },
  ],
);

/**
 * @generated from message omnios.v1.TrialBalance
 */
export const TrialBalance = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TrialBalance",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lines", kind: "message", T: AccountBalance, repeated: true },
    { no: 4, name: "total_debits", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "total_credits", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.FinancialStatement
 */
export const FinancialStatement = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinancialStatement",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "report_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "lines", kind: "message", T: ReportLine, repeated: true },
    { no: 7, name: "total", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReportLine
 */
export const ReportLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReportLine",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "indent", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "is_total", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.CashFlowSection
 */
export const CashFlowSection = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CashFlowSection",
  () => [
    { no: 1, name: "lines", kind: "message", T: ReportLine, repeated: true },
    { no: 2, name: "subtotal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CashFlowStatement
 */
export const CashFlowStatement = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CashFlowStatement",
  () => [
    { no: 1, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "operating", kind: "message", T: CashFlowSection },
    { no: 4, name: "investing", kind: "message", T: CashFlowSection },
    { no: 5, name: "financing", kind: "message", T: CashFlowSection },
    { no: 6, name: "net_change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "opening_cash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "closing_cash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.LedgerSchemaProto
 */
export const LedgerSchemaProto = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.LedgerSchemaProto",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "chart_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "entry_types_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.AgentDecision
 */
export const AgentDecision = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AgentDecision",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "decision_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(DecisionStatus) },
    { no: 6, name: "input_data", kind: "message", T: Struct },
    { no: 7, name: "output_data", kind: "message", T: Struct },
    { no: 8, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "resolved_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "resolved_at", kind: "message", T: Timestamp },
    { no: 11, name: "entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.AutonomyConfig
 */
export const AutonomyConfig = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AutonomyConfig",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "posting_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "recon_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "close_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "compliance_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "approval_threshold", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReconSession
 */
export const ReconSession = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReconSession",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bank_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "statement_date", kind: "message", T: Timestamp },
    { no: 5, name: "statement_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "book_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "match_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "unmatched_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.MatchProposal
 */
export const MatchProposal = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MatchProposal",
  () => [
    { no: 1, name: "statement_line_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "book_entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "strategy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "amount_variance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CloseChecklist
 */
export const CloseChecklist = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CloseChecklist",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "steps", kind: "message", T: CloseTask, repeated: true },
    { no: 3, name: "progress_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "is_complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.CloseTask
 */
export const CloseTask = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CloseTask",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entries_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "completed_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.BudgetLineVariance
 */
export const BudgetLineVariance = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BudgetLineVariance",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "budget_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "actual_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "variance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "variance_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.BudgetVarianceResponse
 */
export const BudgetVarianceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BudgetVarianceResponse",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lines", kind: "message", T: BudgetLineVariance, repeated: true },
    { no: 3, name: "total_budget", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_actual", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "total_variance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.IcTransaction
 */
export const IcTransaction = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.IcTransaction",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "from_entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "to_entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "from_entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "to_entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ConsolidationResult
 */
export const ConsolidationResult = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ConsolidationResult",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "consolidated_balance_sheet", kind: "message", T: FinancialStatement },
    { no: 4, name: "consolidated_income_statement", kind: "message", T: FinancialStatement },
    { no: 5, name: "eliminations_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "run_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreditCheckResult
 */
export const CreditCheckResult = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreditCheckResult",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "credit_limit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "current_exposure", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "available", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "approved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AccountStatementLine
 */
export const AccountStatementLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AccountStatementLine",
  () => [
    { no: 1, name: "date", kind: "message", T: Timestamp },
    { no: 2, name: "entry_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "debit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "credit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "running_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AccountStatementResponse
 */
export const AccountStatementResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AccountStatementResponse",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "opening_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lines", kind: "message", T: AccountStatementLine, repeated: true },
    { no: 5, name: "closing_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.PostEntryRequest
 */
export const PostEntryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PostEntryRequest",
  () => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "valid_date", kind: "message", T: Timestamp },
    { no: 5, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "entry_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "origin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "lines", kind: "message", T: JournalLineInput, repeated: true },
    { no: 10, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "groups", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.JournalLineInput
 */
export const JournalLineInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.JournalLineInput",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 4, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "reporting_amounts", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 7, name: "dimensions", kind: "message", T: Struct },
    { no: 8, name: "quantity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "tax_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEntryRequest
 */
export const GetEntryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEntryRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEntriesRequest
 */
export const ListEntriesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEntriesRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(EntryStatus), opt: true },
    { no: 7, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEntriesResponse
 */
export const ListEntriesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEntriesResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: JournalEntry, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ReverseEntryRequest
 */
export const ReverseEntryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReverseEntryRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "valid_date", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.DraftEntryRequest
 */
export const DraftEntryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DraftEntryRequest",
  () => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "valid_date", kind: "message", T: Timestamp },
    { no: 5, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "entry_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "lines", kind: "message", T: JournalLineInput, repeated: true },
    { no: 9, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "groups", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ApproveEntryRequest
 */
export const ApproveEntryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveEntryRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateAccountRequest
 */
export const CreateAccountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateAccountRequest",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account_type", kind: "enum", T: proto3.getEnumType(AccountType) },
    { no: 4, name: "normal_balance", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "is_group", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_template", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "dimensions", kind: "message", T: Struct },
    { no: 10, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "properties", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.GetAccountRequest
 */
export const GetAccountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetAccountRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateAccountRequest
 */
export const UpdateAccountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateAccountRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "dimensions", kind: "message", T: Struct },
    { no: 7, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "properties", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ListAccountsRequest
 */
export const ListAccountsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAccountsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "account_type", kind: "enum", T: proto3.getEnumType(AccountType), opt: true },
    { no: 5, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "is_group", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAccountsResponse
 */
export const ListAccountsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAccountsResponse",
  () => [
    { no: 1, name: "accounts", kind: "message", T: Account, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.GetBalanceRequest
 */
export const GetBalanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetBalanceRequest",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "as_of", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.GetTrialBalanceRequest
 */
export const GetTrialBalanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTrialBalanceRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "as_of", kind: "message", T: Timestamp },
    { no: 4, name: "dimensions_filter", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.GetReportRequest
 */
export const GetReportRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetReportRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "comparative", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "dimensions_filter", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.GetAccountStatementRequest
 */
export const GetAccountStatementRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetAccountStatementRequest",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_date", kind: "message", T: Timestamp },
    { no: 3, name: "to_date", kind: "message", T: Timestamp },
    { no: 4, name: "page", kind: "message", T: PageRequest },
    { no: 5, name: "dimensions_filter", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ListPeriodsRequest
 */
export const ListPeriodsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPeriodsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(PeriodStatus), opt: true },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
  ],
);

/**
 * @generated from message omnios.v1.ListPeriodsResponse
 */
export const ListPeriodsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPeriodsResponse",
  () => [
    { no: 1, name: "periods", kind: "message", T: FiscalPeriod, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.GetCloseChecklistRequest
 */
export const GetCloseChecklistRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCloseChecklistRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RunCloseAgentRequest
 */
export const RunCloseAgentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunCloseAgentRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dry_run", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.RunCloseAgentResponse
 */
export const RunCloseAgentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunCloseAgentResponse",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "checklist", kind: "message", T: CloseChecklist },
    { no: 4, name: "entries_created", kind: "message", T: JournalEntry, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ClosePeriodRequest
 */
export const ClosePeriodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ClosePeriodRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReopenPeriodRequest
 */
export const ReopenPeriodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReopenPeriodRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.StoreSchemaRequest
 */
export const StoreSchemaRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StoreSchemaRequest",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "chart_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "entry_types_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetSchemaRequest
 */
export const GetSchemaRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSchemaRequest",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListSchemasRequest
 */
export const ListSchemasRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSchemasRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListSchemasResponse
 */
export const ListSchemasResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSchemasResponse",
  () => [
    { no: 1, name: "schemas", kind: "message", T: LedgerSchemaProto, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.CreateReconSessionRequest
 */
export const CreateReconSessionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateReconSessionRequest",
  () => [
    { no: 1, name: "bank_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "statement_date", kind: "message", T: Timestamp },
    { no: 3, name: "statement_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetReconSessionRequest
 */
export const GetReconSessionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetReconSessionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RunAutoMatchRequest
 */
export const RunAutoMatchRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunAutoMatchRequest",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RunAutoMatchResponse
 */
export const RunAutoMatchResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunAutoMatchResponse",
  () => [
    { no: 1, name: "proposals", kind: "message", T: MatchProposal, repeated: true },
    { no: 2, name: "matched_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "unmatched_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.AcceptMatchRequest
 */
export const AcceptMatchRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AcceptMatchRequest",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "statement_line_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "book_entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.FinalizeReconRequest
 */
export const FinalizeReconRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FinalizeReconRequest",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListDecisionsRequest
 */
export const ListDecisionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDecisionsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(DecisionStatus), opt: true },
    { no: 5, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "decision_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListDecisionsResponse
 */
export const ListDecisionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDecisionsResponse",
  () => [
    { no: 1, name: "decisions", kind: "message", T: AgentDecision, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ApproveDecisionRequest
 */
export const ApproveDecisionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveDecisionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RejectDecisionRequest
 */
export const RejectDecisionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RejectDecisionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetAutonomyConfigRequest
 */
export const GetAutonomyConfigRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetAutonomyConfigRequest",
  [],
);

/**
 * @generated from message omnios.v1.SetAutonomyConfigRequest
 */
export const SetAutonomyConfigRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetAutonomyConfigRequest",
  () => [
    { no: 1, name: "posting_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "recon_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "close_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "compliance_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "approval_threshold", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetBudgetVarianceRequest
 */
export const GetBudgetVarianceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetBudgetVarianceRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.SetBudgetAmountRequest
 */
export const SetBudgetAmountRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetBudgetAmountRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateFixedAssetRequest
 */
export const CreateFixedAssetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateFixedAssetRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "asset_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "acquisition_cost", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "salvage_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "useful_life_months", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "depreciation_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "acquisition_date", kind: "message", T: Timestamp },
    { no: 8, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "depreciation_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "properties", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ListFixedAssetsRequest
 */
export const ListFixedAssetsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListFixedAssetsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListFixedAssetsResponse
 */
export const ListFixedAssetsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListFixedAssetsResponse",
  () => [
    { no: 1, name: "assets", kind: "message", T: FixedAsset, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.DisposeFixedAssetRequest
 */
export const DisposeFixedAssetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DisposeFixedAssetRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "disposal_date", kind: "message", T: Timestamp },
    { no: 3, name: "proceeds", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CheckCreditRequest
 */
export const CheckCreditRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CheckCreditRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CheckCreditResponse
 */
export const CheckCreditResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CheckCreditResponse",
  () => [
    { no: 1, name: "result", kind: "message", T: CreditCheckResult },
  ],
);

/**
 * @generated from message omnios.v1.ListIcTransactionsRequest
 */
export const ListIcTransactionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListIcTransactionsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListIcTransactionsResponse
 */
export const ListIcTransactionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListIcTransactionsResponse",
  () => [
    { no: 1, name: "transactions", kind: "message", T: IcTransaction, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.RunConsolidationRequest
 */
export const RunConsolidationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunConsolidationRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "eliminate_ic", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.RunConsolidationResponse
 */
export const RunConsolidationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunConsolidationResponse",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "result", kind: "message", T: ConsolidationResult },
  ],
);

/**
 * @generated from message omnios.v1.GetAccountAnalysisRequest
 */
export const GetAccountAnalysisRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetAccountAnalysisRequest",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "dimensions_filter", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.AccountAnalysisLine
 */
export const AccountAnalysisLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AccountAnalysisLine",
  () => [
    { no: 1, name: "offset_account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "offset_account_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "debit_turnover", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "credit_turnover", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AccountAnalysisResponse
 */
export const AccountAnalysisResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AccountAnalysisResponse",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "opening_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lines", kind: "message", T: AccountAnalysisLine, repeated: true },
    { no: 5, name: "total_debit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "total_credit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "closing_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCrossTabBalanceRequest
 */
export const GetCrossTabBalanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCrossTabBalanceRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "dimensions_filter", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.CrossTabCell
 */
export const CrossTabCell = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CrossTabCell",
  () => [
    { no: 1, name: "debit_account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "credit_account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CrossTabBalanceResponse
 */
export const CrossTabBalanceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CrossTabBalanceResponse",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "debit_accounts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "credit_accounts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "cells", kind: "message", T: CrossTabCell, repeated: true },
    { no: 5, name: "row_totals", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 6, name: "col_totals", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message omnios.v1.RecurringEntryTemplate
 */
export const RecurringEntryTemplate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RecurringEntryTemplate",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "cron_expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "lines", kind: "message", T: RecurringLine, repeated: true },
    { no: 10, name: "next_run", kind: "message", T: Timestamp },
    { no: 11, name: "last_run", kind: "message", T: Timestamp },
    { no: 12, name: "last_entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.RecurringLine
 */
export const RecurringLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RecurringLine",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 3, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateRecurringEntryRequest
 */
export const CreateRecurringEntryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateRecurringEntryRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cron_expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "basis", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "lines", kind: "message", T: RecurringLine, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListRecurringEntriesRequest
 */
export const ListRecurringEntriesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRecurringEntriesRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListRecurringEntriesResponse
 */
export const ListRecurringEntriesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRecurringEntriesResponse",
  () => [
    { no: 1, name: "templates", kind: "message", T: RecurringEntryTemplate, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.UpdateRecurringEntryRequest
 */
export const UpdateRecurringEntryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateRecurringEntryRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "cron_expression", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "lines", kind: "message", T: RecurringLine, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteRecurringEntryRequest
 */
export const DeleteRecurringEntryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteRecurringEntryRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListWorkflowsRequest
 */
export const ListWorkflowsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWorkflowsRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.WorkflowDef
 */
export const WorkflowDef = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkflowDef",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_run_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "last_run_at", kind: "message", T: Timestamp },
    { no: 6, name: "last_entries_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListWorkflowsResponse
 */
export const ListWorkflowsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWorkflowsResponse",
  () => [
    { no: 1, name: "workflows", kind: "message", T: WorkflowDef, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RunWorkflowRequest
 */
export const RunWorkflowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunWorkflowRequest",
  () => [
    { no: 1, name: "workflow_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "dry_run", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "params", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.RunWorkflowResponse
 */
export const RunWorkflowResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunWorkflowResponse",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entries_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchPostEntriesRequest
 */
export const BatchPostEntriesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchPostEntriesRequest",
  () => [
    { no: 1, name: "entry_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BatchPostEntriesResponse
 */
export const BatchPostEntriesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchPostEntriesResponse",
  () => [
    { no: 1, name: "success_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "failure_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "failed_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "error_messages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BatchReverseEntriesRequest
 */
export const BatchReverseEntriesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchReverseEntriesRequest",
  () => [
    { no: 1, name: "entry_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BatchReverseEntriesResponse
 */
export const BatchReverseEntriesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BatchReverseEntriesResponse",
  () => [
    { no: 1, name: "success_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "failure_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "failed_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RunQualityCheckRequest
 */
export const RunQualityCheckRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunQualityCheckRequest",
  () => [
    { no: 1, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "check_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.QualityCheckIssue
 */
export const QualityCheckIssue = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.QualityCheckIssue",
  () => [
    { no: 1, name: "check_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "severity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "details", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.RunQualityCheckResponse
 */
export const RunQualityCheckResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunQualityCheckResponse",
  () => [
    { no: 1, name: "issues", kind: "message", T: QualityCheckIssue, repeated: true },
    { no: 2, name: "error_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "warning_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "info_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCounterpartyReconRequest
 */
export const GetCounterpartyReconRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCounterpartyReconRequest",
  () => [
    { no: 1, name: "counterparty_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "period_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.CounterpartyReconLine
 */
export const CounterpartyReconLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CounterpartyReconLine",
  () => [
    { no: 1, name: "date", kind: "message", T: Timestamp },
    { no: 2, name: "document_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "debit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "credit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "entry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCounterpartyReconResponse
 */
export const GetCounterpartyReconResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCounterpartyReconResponse",
  () => [
    { no: 1, name: "counterparty_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "opening_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lines", kind: "message", T: CounterpartyReconLine, repeated: true },
    { no: 5, name: "closing_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "total_debit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "total_credit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SimulateInScenarioRequest
 */
export const SimulateInScenarioRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SimulateInScenarioRequest",
  () => [
    { no: 1, name: "scenario_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "events", kind: "message", T: SimulatedEvent, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SimulatedEvent
 */
export const SimulatedEvent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SimulatedEvent",
  () => [
    { no: 1, name: "source_context", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source_entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "payload", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.SimulateInScenarioResponse
 */
export const SimulateInScenarioResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SimulateInScenarioResponse",
  () => [
    { no: 1, name: "scenario_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "deltas", kind: "message", T: StatementDelta, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.StatementDelta
 */
export const StatementDelta = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StatementDelta",
  () => [
    { no: 1, name: "account_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "current_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "projected_balance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "delta", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

